import React, { useEffect, useState, useRef } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { isAuthenticated } from '../../../../services/auth';
import {
  message,
  Popconfirm,
} from 'antd';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button as MUIButton } from '@mui/material';
import { Edit as EditIcon, Delete as DeleteIcon } from '@mui/icons-material';
import { MUIPagination } from '../../../../components/ui/pagination';
import { addCategory, allCategories, deleteCategory } from '../../../../services/category';
import moment from 'moment';
import throttle from 'lodash/throttle';
import UnifiedDashboard from '../../../../components/layout/unified-dashboard';

const AddCategory = () => {
  const history = useHistory();
  const [name, setName] = useState('');
  const [type, setType] = useState('produto');
  const countPerPage = 5;
  const [categories, setCategories] = useState({
    category: [],
    pagination: [],
    deleted: false,
    newAdded: false,
  });
  const [current, setCurrent] = useState();
  const [search, setSearch] = useState('');
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const { category, pagination, deleted, newAdded } = categories;

  const { token } = isAuthenticated();

  const searchData = useRef(
    throttle(async (val) => {
      const query = val.toLowerCase();
      setCurrent(1);
      const data = await allCategories();
      const newData = data.data
        .filter((item) => item.name.toLowerCase().indexOf(query) > -1)
        .slice(0, countPerPage);
      setCategories({ ...categories, pagination: newData });
    }, 400)
  );

  useEffect(() => {
    if (!search) {
      loadCategories(1);
    } else {
      searchData.current(search);
    }
  }, [search, newAdded, deleted]);

  const loadCategories = async (page) => {
    const res = await allCategories();
    setCurrent(page);
    const to = page * countPerPage;
    const from = to - countPerPage;
    setCategories({ category: res.data, pagination: res.data.slice(from, to) });
  };

  const handleDelete = async (categoryId) => {
    const res = await deleteCategory(categoryId, token);
    if (res.error) {
      console.log(res.error);
    } else {
      console.log(res);
      message.success('Categoria excluída', 4);
      setCategories({ ...categories, deleted: true });
    }
  };

  const handleChange = (e) => {
    setName(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await addCategory({ name, type });
      console.log(res);
      message.success('Categoria adicionada', 4);
      setName('');
      setType('produto');
      setCategories({ ...categories, newAdded: true });
    } catch (err) {
      console.log(err);
      if (err.response.status === 400) message.error(err.response.data, 4);
    }
  };

  return (
    <UnifiedDashboard title="Gerenciar Categorias">
      <div className='admin-page-container'>
        {/* Header */}
        <div className='admin-page-header'>
          <div className='admin-page-header-content'>
            <h2 className='admin-page-title'>
              <i className='fas fa-tags'></i>
              Gerenciar Categorias
            </h2>
            <p className='admin-page-subtitle'>Administre as categorias do sistema</p>
          </div>
        </div>

        {/* Add Form Card */}
        <div className='admin-card'>
          <div className='admin-card-header'>
            <h3 className='admin-card-title'>
              <i className='fas fa-plus-circle'></i>
              Nova Categoria
            </h3>
          </div>
          <div className='admin-card-body'>
            <form onSubmit={handleSubmit} className='admin-form'>
              <div className='admin-form-group'>
                <label className='admin-form-label'>Tipo</label>
                <select
                  className='admin-form-input'
                  value={type}
                  onChange={(e) => setType(e.target.value)}
                  required
                >
                  <option value='produto'>Imóvel</option>
                  <option value='servico'>Serviço</option>
                </select>
              </div>
              <div className='admin-form-group'>
                <label className='admin-form-label'>Nome da Categoria</label>
                <input
                  type='text'
                  className='admin-form-input'
                  placeholder='Ex: Eletrônicos, Roupas, Alimentos...'
                  value={name}
                  onChange={handleChange}
                  required
                />
              </div>
              <button type='submit' className='admin-form-submit-btn'>
                <i className='fas fa-plus'></i> Adicionar Categoria
              </button>
            </form>
          </div>
        </div>

        {/* List Card */}
        <div className='admin-card'>
          <div className='admin-card-header'>
            <h3 className='admin-card-title'>
              <i className='fas fa-list'></i>
              Categorias Registradas
            </h3>
            <div className='admin-search-box'>
              <i className='fas fa-search'></i>
              <input
                type='text'
                className='admin-search-input'
                placeholder='Buscar categoria...'
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
          </div>
          <div className='admin-card-body'>
            {pagination && pagination.length > 0 ? (
              <>
                <div className='admin-table-wrapper'>
                  <table className='admin-table'>
                    <thead>
                      <tr>
                        <th><i className='fas fa-tag'></i> Nome</th>
                        <th><i className='fas fa-calendar'></i> Data</th>
                        <th className='text-center'><i className='fas fa-cogs'></i> Ações</th>
                      </tr>
                    </thead>
                    <tbody>
                      {pagination.map((c, i) => (
                        <tr key={i}>
                          <td>{c.name}</td>
                          <td>{moment(c.createdAt).format('DD/MM/YYYY')}</td>
                          <td className='admin-table-actions'>
                            <MUIButton
                              startIcon={<EditIcon />}
                              className='admin-btn admin-btn-edit'
                              onClick={() => history.push(`/admin/category/edit/${c._id}`)}
                              title='Editar'
                              sx={{ mr: 1 }}
                            >
                              Editar
                            </MUIButton>
                            <MUIButton
                              startIcon={<DeleteIcon />}
                              className='admin-btn admin-btn-delete'
                              onClick={() => { setSelectedCategory(c); setDeleteDialog(true); }}
                              title='Excluir'
                            >
                              Excluir
                            </MUIButton>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <div className='admin-pagination'>
                  <MUIPagination
                    count={Math.ceil(category.length / countPerPage)}
                    page={current || 1}
                    onChange={loadCategories}
                    color="primary"
                    size="medium"
                    showFirstButton={Math.ceil(category.length / countPerPage) > 5}
                    showLastButton={Math.ceil(category.length / countPerPage) > 5}
                  />
                </div>
              </>
            ) : (
              <div className='admin-empty-state'>
                <i className='fas fa-inbox'></i>
                <p>Nenhuma categoria encontrada</p>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Delete Dialog */}
      <Dialog
        open={deleteDialog}
        onClose={() => setDeleteDialog(false)}
      >
        <DialogTitle>Excluir categoria</DialogTitle>
        <DialogContent>
          <p>Tem certeza que deseja excluir {selectedCategory?.name}? Esta ação não pode ser desfeita.</p>
        </DialogContent>
        <DialogActions>
          <MUIButton onClick={() => setDeleteDialog(false)}>Cancelar</MUIButton>
          <MUIButton onClick={() => { 
            handleDelete(selectedCategory._id);
            setDeleteDialog(false);
          }}>Excluir</MUIButton>
        </DialogActions>
      </Dialog>
    </UnifiedDashboard>
  );
};

export default AddCategory;
